/* eslint-disable no-alert */
import { Clickable } from '@carvana/vdp-components';
import { COOKIES } from '~/constants';
import { commonEnvironment } from '~/constants/environment';
import BrowserCookies from '~/utilities/BrowserCookies';

function clearFeatureBranch(): void {
  BrowserCookies.remove(COOKIES.featureBranchEnabled);
  BrowserCookies.remove(COOKIES.featureBranchName);

  window.location.reload();
}

function setFeatureBranch(): void {
  const branchName = prompt('Feature branch name?');

  if (!branchName) return;

  const featureBranchName = branchName
    .toLowerCase()
    .match(/reo-[0-9a-z-]*/)?.[0];

  if (featureBranchName) {
    BrowserCookies.set(COOKIES.featureBranchEnabled, 'true');
    BrowserCookies.set(
      COOKIES.featureBranchName,
      `carvana-merch-serenity-ui-${featureBranchName}`
    );

    window.location.reload();
  } else {
    alert(`Could not parse a feature branch name from ${branchName}.`);
  }
}

export default function FeatureBranch() {
  const isEnabled = BrowserCookies.get(COOKIES.featureBranchEnabled) === 'true';
  const branchName = BrowserCookies.get(COOKIES.featureBranchName);

  return commonEnvironment === 'test' ? (
    <div className="absolute inset-0 pointer-events-none z-50">
      <div className="max-w-[1800px] mx-auto">
        {isEnabled ? (
          <div className="bg-yellow-2 flex items-center m-4 opacity-90 p-4 m:w-fit">
            <div className="flex-1">
              <p className="m:inline">Using feature branch </p>
              <p className="font-mono text-xs m:inline">{branchName}</p>
            </div>
            <Clickable
              element="span"
              onClick={clearFeatureBranch}
              className="leading-none pointer-events-auto px-8 text-2xl"
              data-analytics-id="Clear feature branch"
              title="Clear feature branch"
            >
              ×
            </Clickable>
          </div>
        ) : (
          <button
            type="button"
            onClick={setFeatureBranch}
            className="opacity-0 pointer-events-auto"
            data-analytics-id="Set feature branch"
            title="Set feature branch"
          >
            Set feature branch
          </button>
        )}
      </div>
    </div>
  ) : null;
}
